import { apiRequest, sendFormData } from './_tools';

export function fetchAccountManagers({ page, itemsPerPage, sort }) {
  return apiRequest(`/api/accountManagersWithPaging?page=${page}` +
    `&itemsPerPage=${itemsPerPage}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
    .catch(({ error }) => Promise.reject(error));
}

export function fetchAllAccountManagers() {
  return apiRequest('/api/accountManagers')
    .catch(({ error }) => Promise.reject(error));
}

export function addAccountManager(accountManager) {
  return sendFormData('/api/accountManagers', accountManager)
    .catch(({ error }) => Promise.reject(error));
}

export function updateAccountManager({ accountManagerId, accountManager }) {
  return sendFormData(`/api/accountManagers/${accountManagerId}`, accountManager, 'PUT');
}



/** WEBPACK FOOTER **
 ** ./js/core/api/accountManagers.js
 **/